import script from "./LzwcQuillEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./LzwcQuillEditor.vue?vue&type=script&setup=true&lang=ts"

import "./LzwcQuillEditor.vue?vue&type=style&index=0&id=73837afe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73837afe"]])

export default __exports__